<template>
    <div :style="{ height: param.height ? param.height + 'px' : '100%' }">
        <div
            :id="param.videoId"
            class="dh-bg"
        >
            <div v-if="param.showBg" class="dh-desc">
              <div style='text-align:center;line-height:24px'>
                <div style='color:white'>{{ dhErrorMsg === '插件未安装!'?'您当前未安装播放器插件' : dhErrorMsg}}</div>
                <div style='color:#4680ff' v-if="dhErrorMsg === '插件未安装!'">点击选择合适插件下载安装</div>
                <div>
                    <a v-if="dhErrorMsg === '插件未安装!'" style="font-size: 12px;color:#4680ff;text-decoration:none" href="https://open-icc.dahuatech.com/download/plugins/dhplayer/DHPlayer_x32.zip"><a-icon type="download" /> x32位</a>&nbsp;&nbsp;&nbsp;
                    <a v-if="dhErrorMsg === '插件未安装!'" style="font-size: 12px;color:#4680ff;text-decoration:none" href="https://open-icc.dahuatech.com/download/plugins/dhplayer/DHPlayer_x64.zip"><a-icon type="download" /> x64位</a>
                </div>
             </div>
            </div>
        </div>
    </div>
</template>

<script>
import '../thirdparty/dhplayer/videoPlayer'
// import PanTilt from '../../static/panTilt/panTilt'
import { merge } from 'lodash'
import PanTilt from '../thirdparty/dhplayer/panTilt/panTilt'
import '../thirdparty/dhplayer/panTilt/panTilt.css'
import { initIframeSafety } from './utils/iframeSafety'

export default {
    name: 'DHicc',
    props: {
        // 是否显示背景
        option:{
            type:Object
        },
        src:{
            type:String,
            default:''
        }
    },
    data() {
        return {
            dhErrorMsg: '插件加载中...',
            videoPlayer: null,
            param: {}, // 参数
            isUsePanTilt: false,
            iframeObserver: null
        }
    },
    beforeDestroy() {
        // 清理iframe观察器
        if (this.iframeObserver) {
            this.iframeObserver.disconnect();
            this.iframeObserver = null;
        }
        this.destroy()
    },
    mounted() {
        // this.$nextTick(() => {
        //     this.init()
        // })
    },
    watch: {
        'option.windowType': {
            handler(v) {
                this.__update(v, 'windowType')
            },
            deep: true,
            immediate: true
        },
        'option.pIframeRect': {
            handler(v) {
                this.__update(v, 'pIframeRect')
            },
            deep: true,
            immediate: true
        },
        'option.num': {
            handler(v) {
                this.__update(Number(v), 'division')
            },
            deep: true,
            immediate: true
        },
        'option.visible': {
            handler(v) {
                if(!v) {
                    this.dhErrorMsg = ''
                }
                this.__update(v, 'visible')
            },
            deep: true,
            immediate: true
        },
        'option.draggable': {
            handler(v) {
                this.__update(v, "draggable")
            },
            deep: true,
            immediate: true
        },
        'option.division': {
            handler(v) {
                this.__update(v, 'division')
            },
            deep: true,
            immediate: true
        },
        'option.request': {
            handler(v) {
                this.__update(v, 'request')
            },
            deep: true,
            immediate: true
        },
        'option.showBar': {
            handler(v) {
                this.__update(v, 'showBar')
            },
            deep: true,
            immediate: true
        },
        'option.shieldClass': {
            handler(v) {
                this.__update(v, 'shieldClass')
            },
            deep: true,
            immediate: true
        },
        'option.coverShieldClass': {
            handler(v) {
                this.__update(v, 'coverShieldClass')
            },
            deep: true,
            immediate: true
        },
        'option.parentIframeShieldClass': {
            handler(v) {
                this.__update(v, 'parentIframeShieldClass')
            },
            deep: true,
            immediate: true
        },
        dhErrorMsg:{
            handler(v){
                console.warn('----------------dhErrorMsg',v);
            }
        }
    },
    methods: {
        defaultOptions(){
            return {
                videoId:'dhplayer',
                windowType:0,
                // coverShieldClass:['ant-layout-content'],
                // shieldClass:[
                //         'test_drop',
                //         'streamTypeClass',
                //         'datePickerClass',
                //         'recordSourceClass'
                //     ],
                // division:'{"hwnd":0,"nCol":6,"nRow":6,"nSplitCount":6,"stuWnds":[{"bEnable":true,"nCombine":0,"x1":0,"x2":1,"y1":0,"y2":3},{"bEnable":true,"nCombine":1,"x1":1,"x2":3,"y1":0,"y2":3},{"bEnable":false,"nCombine":1,"x1":1,"x2":3,"y1":0,"y2":3},{"bEnable":true,"nCombine":3,"x1":3,"x2":5,"y1":0,"y2":3},{"bEnable":false,"nCombine":3,"x1":3,"x2":5,"y1":0,"y2":3},{"bEnable":true,"nCombine":5,"x1":5,"x2":6,"y1":0,"y2":3},{"bEnable":false,"nCombine":0,"x1":0,"x2":1,"y1":0,"y2":3},{"bEnable":false,"nCombine":1,"x1":1,"x2":3,"y1":0,"y2":3},{"bEnable":false,"nCombine":1,"x1":1,"x2":3,"y1":0,"y2":3},{"bEnable":false,"nCombine":3,"x1":3,"x2":5,"y1":0,"y2":3},{"bEnable":false,"nCombine":3,"x1":3,"x2":5,"y1":0,"y2":3},{"bEnable":false,"nCombine":5,"x1":5,"x2":6,"y1":0,"y2":3},{"bEnable":false,"nCombine":0,"x1":0,"x2":1,"y1":0,"y2":3},{"bEnable":false,"nCombine":1,"x1":1,"x2":3,"y1":0,"y2":3},{"bEnable":false,"nCombine":1,"x1":1,"x2":3,"y1":0,"y2":3},{"bEnable":false,"nCombine":3,"x1":3,"x2":5,"y1":0,"y2":3},{"bEnable":false,"nCombine":3,"x1":3,"x2":5,"y1":0,"y2":3},{"bEnable":false,"nCombine":5,"x1":5,"x2":6,"y1":0,"y2":3},{"bEnable":true,"nCombine":18,"x1":0,"x2":3,"y1":3,"y2":6},{"bEnable":false,"nCombine":18,"x1":0,"x2":3,"y1":3,"y2":6},{"bEnable":false,"nCombine":18,"x1":0,"x2":3,"y1":3,"y2":6},{"bEnable":true,"nCombine":21,"x1":3,"x2":6,"y1":3,"y2":6},{"bEnable":false,"nCombine":21,"x1":3,"x2":6,"y1":3,"y2":6},{"bEnable":false,"nCombine":21,"x1":3,"x2":6,"y1":3,"y2":6},{"bEnable":false,"nCombine":18,"x1":0,"x2":3,"y1":3,"y2":6},{"bEnable":false,"nCombine":18,"x1":0,"x2":3,"y1":3,"y2":6},{"bEnable":false,"nCombine":18,"x1":0,"x2":3,"y1":3,"y2":6},{"bEnable":false,"nCombine":21,"x1":3,"x2":6,"y1":3,"y2":6},{"bEnable":false,"nCombine":21,"x1":3,"x2":6,"y1":3,"y2":6},{"bEnable":false,"nCombine":21,"x1":3,"x2":6,"y1":3,"y2":6},{"bEnable":false,"nCombine":18,"x1":0,"x2":3,"y1":3,"y2":6},{"bEnable":false,"nCombine":18,"x1":0,"x2":3,"y1":3,"y2":6},{"bEnable":false,"nCombine":18,"x1":0,"x2":3,"y1":3,"y2":6},{"bEnable":false,"nCombine":21,"x1":3,"x2":6,"y1":3,"y2":6},{"bEnable":false,"nCombine":21,"x1":3,"x2":6,"y1":3,"y2":6},{"bEnable":false,"nCombine":21,"x1":3,"x2":6,"y1":3,"y2":6}]}',
                request: {},
                showBg:true,
                height:0,
                visible:true,
                draggable:false,
                division:1,
                showBar:true,
                shieldClass:[],
                coverShieldClass:[],
                parentIframeShieldClass:[
                    'baidu-iframe', 
                    'chat-iframe', 
                    'external-iframe', 
                    'embed-iframe',
                    'chat-container-iframe'
                ],

            }
        },

        created () {
            // console.warn('option--------------',this.option)
            // console.warn('defaultOptions--------------',this.defaultOptions)
            // this.param = merge(this.defaultOptions(), this.option)
            // console.warn('param=========',this.param)
        },
        __update(v, type) {
            this.param[type] = v
            this.videoPlayer && this.videoPlayer._update({ ...this.param })
        },
        init() {
            console.warn('option--------------',this.option)
            console.warn('defaultOptions--------------',this.defaultOptions)
            this.param = merge(this.defaultOptions(), this.option)
            console.warn('param=========',this.param)
            console.warn('init')
            
            // 初始化iframe安全处理
            this.iframeObserver = initIframeSafety();
            
            let {
                windowType,
                visible,
                draggable,
                division,
                showBar,
                shieldClass,
                coverShieldClass,
                parentIframeShieldClass
            } = this.param
            
            // 确保parentIframeShieldClass数组包含CSP相关的类名
            if (this.param.parentIframeShieldClass && !this.param.parentIframeShieldClass.includes('baidu-iframe')) {
                this.param.parentIframeShieldClass = [
                    ...this.param.parentIframeShieldClass, 
                    'baidu-iframe', 
                    'chat-iframe', 
                    'external-iframe', 
                    'embed-iframe',
                    'chat-container-iframe'
                ];
            }

            this.videoPlayer = new VideoPlayer({
                videoId: this.param.videoId,
                outContent: {
                    left: 0,
                    right: 0,
                    width: 0,
                    height: 0
                },
                windowType: windowType || 0,
                shieldClass: shieldClass || [],
                coverShieldClass: coverShieldClass || [],
                parentIframeShieldClass: this.param.parentIframeShieldClass || [],
                showBar,
                division,
                visible,
                draggable,
                request: this.param.request || {
                    real: null, // 实时预览
                    talk: null, // 对讲
                    stopTalk: null, // 停止对讲
                    playbackByTime: null, // 通过时间录像回访
                    playbackByFile: null, // 通过文件录像回放
                    queryRecord: null // 查询录像
                },
                // 创建播放器成功
                createSuccess: (versionInfo) => {
                    console.warn('createSuccess warn',versionInfo.message)
                    this.$emit('createSuccess', versionInfo)
                },
                // 播放器创建失败
                createError: err => {
                    console.log('-----播放器加载失败，错误原因：', err)
                    sessionStorage.setItem('dhplayer-info', err.message)
                    this.dhErrorMsg = err.message
                    this.$emit('createError', err)
                },
                // 消息提示汇总
                dhPlayerMessage: (info, err) => {
                    this.$emit("dhPlayerMessage", info, err)
                },
                // 抓图成功
                snapshotSuccess: ({ base64Url, path }, info) => {
                    this.$emit('picCap', {
                        base64Url,
                        path
                    }, info)
                },
                // 实时预览成功回调
                realSuccess: (info) => {
                    console.log('实时预览成功回调',info)
                    this.$emit('realSuccess', info)
                },
                // 实时预览错误回调
                realError: (info, err) => {
                    console.log('实时预览错误回调',info, err)
                    this.$emit('realError', info, err)
                },
                // 对讲成功回调
                talkSuccess: (info) => {
                    this.$emit('talkSuccess', info)
                },
                // 对讲错误回调
                talkError: (info, err) => {
                    console.log(info, err)
                    this.$emit('talkError', info, err)
                },
                // 录像回放成功回调
                playbackSuccess: (info) => {
                    console.log('录像回放成功回调,playbackSuccess',info);
                    this.$emit('playbackSuccess', info)
                },
                // 录像错误，录像播放完成回调
                playbackError: (info, err) => {
                    console.log(info, err, '录像错误，录像播放完成回调, playbackError')
                    this.$emit('playbackError', info, err)
                },
                // 录像播放完成
                playbackFinish: (info) => {
                    this.$emit('playbackFinish', info)
                },
                // 点击对讲按钮的回调
                notifyTalk: ({ channelId, snum }) => {
                    this.$emit('notifyTalk', { channelId, snum })
                },
                //录像回放时间栏拖拽回调
                // 拖拽后需要重新掉接口获取rtsp地址传入播放器
                switchStartTime: ({ startTime, snum }) => {
                    this.$emit('switchStartTime', {
                        startTime,
                        snum
                    })
                },
                replay: snum => {
                    //录像回放播放结束回调，返回窗口
                    this.$emit('replay', snum)
                },
                // 本地录像下载成功回调
                videoDownloadSuccess: (path, info) => {
                    this.$emit('videoDownloadSuccess', path, info)
                },
                //关闭视频窗口回调
                closeWindowSuccess: ({ isAll, snum, channelList }) => {
                    console.log(`关闭第${snum}个正在播放的视频`);
                    this.$emit('closeWindowSuccess', { isAll, snum, channelList })
                },
                // 窗口单击回调
                clickWindow: (snum, info) => {
                    console.log(`当前点击了第${snum}个窗口`)
                    this.$emit('clickWindow', snum, info)
                    if (this.param.windowType === 0) {
                        this.usePanTilt(info)
                    }
                },
                // 窗口双击回调
                dbClickWindow: (snum, info) => {
                    console.log(`当前双击了第${snum}个窗口`)
                    this.$emit('dbClickWindow', snum, info)
                },
                // 改变当前窗口数回调
                changeDivision: division => {
                    console.log(`当前窗口数量: ${division}`)
                    this.param.division = division
                    this.$emit('changeDivision', division)
                },
                // 下载录像进度
                downloadProgress: (info) => {
                    this.$emit('downloadProgress', info)
                },
                // 下载录像成功回调
                downloadRecordSuccess: (info) => {
                    this.$emit('downloadRecordSuccess', info)
                }
            })
            // if(this.src){
            //     // setTimeout(() => {

            //     // }, 1000);
            //     console.error('init src play');
            //     this.realByUrl(0,this.src)
            // }
        },
        dispose(){
            this.hideWindow()
            this.destroy()
        },
        // 销毁
        destroy() {
            console.log(this.videoPlayer, "this.videoPlayer=====================");
            this.videoPlayer.destroy().then((res) => {
                console.warn('destroySuccess',res);
                this.dhErrorMsg = '插件已销毁'
                this.$emit('destroySuccess')
            })
        },

        /**
         * 云台功能初始化
         */
        initPanTilt(el) {
            this.$nextTick(() => {
                this.realPanControl = new PanTilt({
                    el, // 云台容器id
                    setPtzDirection: this.param.request.setPtzDirection, // 云台方向控制接口
                    setPtzCamera: this.param.request.setPtzCamera // 云台镜头控制接口
                })
                this.isUsePanTilt = true
            })
        },

        // 自定义实时预览顶部按钮配置
        setTabControlBtn(btnList) {
            this.videoPlayer.setTabControlBtn(btnList)
        },

        // 使用云台
        usePanTilt(info) {
            this.isUsePanTilt &&
            info &&
            info.channelId &&
            this.realPanControl &&
            this.realPanControl.setChannel({
                id: info.channelId,
                cameraType: info.cameraType,
                capability: info.capability
            })
        },

        /**
         * @param startReal 实时预览集成
         * @param list [array]
         * @param item.channelId 通道Id （必传）
         * @param item.channelName 通道名称 （必传）
         * @param item.streamType 码流类型 0 所有码流 1 主码流 2 辅码流 （默认所有码流）
         * @param item.dataType 音视频类型  1-视频 2-音频 3-音视频 （默认视频）
         * @param item.snum 窗口号
         */
        startReal(list) {
            this.videoPlayer.startReal(list)
            setTimeout(() => {
                this.usePanTilt(list[0])
            }, 300)
        },
        // 实时预览
        realByUrl(o, snum) {
            this.videoPlayer.realByUrl({
                snum,
                channelId: o.channelId,
                path: o.path || o.url,
                redirect: !!o.redirect
            })
        },
        /**
         * @method startTalk 语音对讲集成
         * snum 窗口号
         * */
        startTalk(snum) {
            this.videoPlayer.startTalk(snum)
        },

        // 通过url进行对讲
        talkByUrl(o, snum = 0) {
            this.videoPlayer.talkByUrl({
                snum,
                path: o.path,
                channelId: o.channelId,
                redirect: false, // 写死
                audioType: o.audioType,
                audioBit: o.audioBit,
                sampleRate: o.sampleRate,
                talkType: o.talkType || 1
            })
        },
        // 关闭对讲
        closeTalk() {
            this.videoPlayer.closeTalk()
        },

        /**
         * @desc 录像回放/录像下载 集成
         * @param param 参数信息
         * @param {String} type 播放类型 playback-录像回放 download-下载录像
         */
        startPlayback(param, type = 'playback') {
            switch(type) {
                case "playback":
                    this.videoPlayer.startPlayback(param)
                    break;
                case "download":
                    this.videoPlayer.startDownloadRecord(param)
                    break;
                default:
                    break;
            }
        },
        //录像回放
        playbackByUrl(o, snum = 0) {
            this.videoPlayer.playbackByUrl({
                snum,
                channelId: o.channelId,
                records: o.records || [], // 内部可以设置参数，回放可进行拖动
                path: o.url || o.path,
                startTime: o.startTime,
                endTime: o.endTime,
                redirect: !!o.redirect
            })
        },
        // 录像继续
        playVideo(snum) {
            this.videoPlayer.controlPlayback({
                snum,
                state: 1
            })
        },
        // 录像暂停
        pauseVideo(snum) {
            this.videoPlayer.controlPlayback({
                snum,
                state: 0
            })
        },
        // 改变当前播放器的窗口数
        changeDivision(division) {
            this.videoPlayer.changeDivision(division)
        },
        // 显隐控制栏
        setShowBar(enable = true) {
            this.param.showBar = enable
            this.videoPlayer.showControlBar(enable)
        },
        // 全屏
        setFullScreen() {
            this.videoPlayer.setFullScreen()
        },
        // 刷新位置
        changePosition() {
            this.videoPlayer.changePosition()
        },
        // 本地录像下载
        localRecordDownload(snum) {
            this.videoPlayer.localRecordDownload(snum)
        },
        //隐藏窗口
        hideWindow() {
            this.dhErrorMsg = ''
            this.videoPlayer.hide()
        },
        //显示窗口
        showWindow() {
            this.videoPlayer.show()
        },
        // 选择窗口
        chooseWindow(snum) {
            this.videoPlayer.chooseWindow(snum, info => {
                info && this.usePanTilt(info)
            })
        },
        // 抓图
        snapshot(snum) {
            this.videoPlayer.snapshot(snum)
        },
        /**
         * @mthod 声音控制开关
         * @param snum 窗口号
         * @param isEnable 开关 true-开, false-关
         */
        openAudio(snum, isEnable = true) {
            this.videoPlayer.openAudio({
                snum,
                isEnable
            })
        },
        // 关闭视频(不传默认全部关闭)
        closeVideo(snum) {
            this.videoPlayer.closeVideo(snum)
        },
        /**
         * @method 是否显示规划线
         * @param Number snum 当前窗口数 (必传)
         * @param Boolean isEnableIVS 是否有规则框 true-是, false-否
         * @param Number|String ivsType 规则框类型 1-智能规则框，2-智能目标框 (不传默认为1)
         *
         */
        isEnableIvs(snum, isEnableIVS = true, ivsType = 1) {
            this.videoPlayer.isEnableIvs({
                snum,
                isEnableIVS,
                ivsType
            })
        },
        // 设置水印
        waterMark(options) {
            this.videoPlayer.waterMark(options)
        },
        //	下载录像(通过rtsp下载)
        downloadRecord(o, snum = 0) {
            this.videoPlayer.downloadRecord({
                snum,
                records: o.records || [], // 内部可以设置参数，回放可进行拖动
                url: o.url || o.path,
                startTime: o.startTime,
                endTime: o.endTime,
                redirect: !!o.redirect //是否重定向，true-重定向，false-非重定向，默认false
            })
        }
    }
}
</script>
<style>
.dh-bg {
    background-color: black;
    height: 100%;
    /* border: 2px solid #2db7f4; */
}
.dh-desc {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    /* font-weight: bold; */
    color:#999999;
    letter-spacing: 3px;
}
</style>
